import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import ImageUpload from './ImageUpload';

interface PromptGeneratorProps {
  onGenerateImages: (prompt: string, refImages: string[]) => Promise<void>;
  referenceImages: string[];
  onUploadImages: (images: string[]) => void;
}

const PromptGenerator: React.FC<PromptGeneratorProps> = ({
  onGenerateImages,
  referenceImages,
  onUploadImages
}) => {
  const { action } = useParams<{ action: string }>();
  const navigate = useNavigate();
  const [isGenerating, setIsGenerating] = useState(false);

  useEffect(() => {
    // Only auto-generate if we have reference images
    if (action && referenceImages.length > 0 && !isGenerating) {
      setIsGenerating(true);
      const prompt = action.replace(/-/g, ' ');

      onGenerateImages(prompt, referenceImages)
        .then(() => {
          navigate('/');
        })
        .catch((error) => {
          console.error('Failed to generate stickers:', error);
          navigate('/');
        })
        .finally(() => {
          setIsGenerating(false);
        });
    }
  }, [action, onGenerateImages, referenceImages, navigate, isGenerating]);

  // If no reference images, show upload screen
  if (referenceImages.length === 0) {
    return (
      <div className="prompt-generator">
        <div className="upload-container" style={{ maxWidth: '600px', margin: '100px auto', padding: '40px', textAlign: 'center' }}>
          <h2>Upload Your Photo First</h2>
          <p>To create a "{action?.replace(/-/g, ' ')}" sticker, we need a photo of you!</p>
          <ImageUpload
            onImagesUploaded={(images) => {
              onUploadImages(images);
            }}
            currentImages={[]}
          />
          <p style={{ marginTop: '20px', fontSize: '0.9rem', color: '#666' }}>
            Your photo stays private and is used only to generate your custom stickers
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="prompt-generator">
      <div className="loading-container">
        <div className="spinner"></div>
        <h2>Generating your "{action?.replace(/-/g, ' ')}" sticker...</h2>
        <p>This may take a few moments</p>
      </div>
    </div>
  );
};

export default PromptGenerator;